export default __webpack_public_path__ + "static/media/variation-white.d6ca0f1f.svg";